import React, { useContext, useEffect, useState } from "react";
import {
    Button,
    TextField,
} from "@mui/material";
import {
    DatePicker,
    TimePicker
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import { Col, Container, Row } from "react-bootstrap";
import language from "../../nls/language.json";
import Context from "../../context/Context";
import "./Maintenance.css";

const INITIAL_PENDENCY = {
    molde_Pend_Key: 0,
    molde_Pend_DataPrevisao: null
}

const UpdateMaintenance = ({ pendency, hangleStatusPendencias }) => {
    const [updatePendancy, setUpdatePendancy] = useState(INITIAL_PENDENCY);

    const {
        selectedCountry
    } = useContext(Context);

    useEffect(() => {
        handleUpdatePendency({
            name: 'molde_Pend_Key',
            value: pendency.molde_Pend_Key
        });
    }, [])

    const handleUpdatePendency = ({ name, value }) => {
        setUpdatePendancy({
            ...updatePendancy,
            [name]: value
        });
    }

    return (
        <Container fluid className=" p-3 m-0">
  
                <Row className="py-3">
                    <Col className="p-0 me-2">
                        <TextField
                            className="w-100"
                            disabled
                            label="Lote"
                            value={pendency.molde_Lote}
                        />
                    </Col>
                    <Col className="p-0 me-2">
                        <TextField
                            className="w-100"
                            disabled
                            label="Código"
                            value={pendency.molde_Codigo}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="p-0 mb-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Data de Entrada"
                                format="DD/MM/YYYY"
                                value={dayjs(pendency.molde_Pend_Entrada)}
                                disabled
                            />
                        </LocalizationProvider>
                    </Col>
                </Row>
                <Row className="pb-3">
                    <Col className="p-0 me-2">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Data de Previsão"
                                format="DD/MM/YYYY"
                                // disabled={pendency.molde_Pend_Status !== "ABERTO"}
                                value={dayjs(pendency.molde_Pend_DataPrevisao)}
                                onChange={(e) => handleUpdatePendency({ name: "molde_Pend_DataPrevisao", value: new Date(e.$d) })}
                            />
                        </LocalizationProvider>
                    </Col>
                    <Col className="p-0 ms-2">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                                label="Hora prevista"
                                ampm={false}
                                disabled={!updatePendancy.molde_Pend_DataPrevisao}
                                defaultValue={dayjs('2023-11-10T00:00')}
                                value={pendency.molde_Pend_DataPrevisao ? dayjs(pendency.molde_Pend_DataPrevisao) : dayjs('2023-11-10T00:00')}
                                onChange={(e) => {
                                    updatePendancy.molde_Pend_DataPrevisao.setHours((e.$H - 3))
                                    updatePendancy.molde_Pend_DataPrevisao.setMinutes(e.$m)
                                }}
                            />
                        </LocalizationProvider>
                    </Col>
                </Row>
                {/* <Row>
                    <Col className="p-0">
            <TextField
              className="w-100"
              name="pend_Obs"
              multiline
              rows={4}
              maxRows={10}
              label="Descrição de Pendência"
              value={pendency.pend_Obs}
              onChange={({ target: { name, value } }) => handleUpdatePendency({ name, value })}
            />
          </Col>
                </Row> */}
                <Row className="pt-3 ">
                    <Col className="p-0 d-flex justify-content-end">
                        <Button
                            variant="contained"
                            onClick={() => {
                                setUpdatePendancy(INITIAL_PENDENCY);
                                hangleStatusPendencias(updatePendancy);
                            }}
                            disabled={!updatePendancy.molde_Pend_DataPrevisao}
                        >
                            {language[selectedCountry.name].Manutencao.modal.editar.btnSalvar}
                        </Button>
                    </Col>
                </Row>
   
        </Container >
    )
}

export default UpdateMaintenance;
